<template>
	<div class="container-fluid p-4">
		<ErrorMessage v-if="config_first_license.get_has_error" />

		<div class="row align-items-center mb-4">
			<div class="col-md-6 col-12 text-md-start text-center mb-3 mb-md-0">
				<h2 class="fw-bolder fw-bold fs-1 mb-3">Instruções</h2>
				<p class="fw-bolder fs-5 text-gray-600">
					Autorize a utilização da webcam e do microfone para assistir as aulas online.
				</p>
				<p class="text-gray-600">
					<small>
						Confira os requisitos mínimos para
						<a
							href="https://support.zoom.us/hc/pt-br/articles/201362023-Zoom-system-requirements-Windows-macOS-Linux"
							target="_blank">
							Windows/Linux
						</a>
						ou
						<a
							href="https://support.zoom.us/hc/pt-br/articles/201179966-Requisitos-de-sistema-para-iOS-iPadOS-e-Android"
							target="_blank">
							Android/iOS
						</a>
					</small>
				</p>
			</div>
			<div class="col-md-6 col-12 d-flex justify-content-center">
				<div id="box-photo" class="d-flex justify-content-center mb-3">
					<img id="photo-preview"
						src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjDuSxM0IFyc9FBHt9Dmwyq6yy55CGDlMexA&usqp=CAU"
						class="rounded"
						style="width: 10rem; height: 10rem"
					/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<button
					v-if="config_first_license.get_show_button_continue"
					class="btn btn-success col-12"
					@click="config_first_license.set_state('test_mic')">
					<i class="fa fa-arrow-right"></i>
					Avançar
				</button>
				<a
					v-if="config_first_license.get_show_button_error"
					class="btn btn-danger col-12"
					href="https://tawk.to/chat/625712c2b0d10b6f3e6d6cfc/1g0i22iep">
					<i class="fas fa-exclamation-triangle"></i>
					Entrar em contato com suporte
				</a>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { configFirstLicenseStore } from '../../stores/configFirstLicense';
	import ErrorMessage from '../../components/ErrorMessage.vue';

	const config_first_license = configFirstLicenseStore();
</script>
